module.exports = __webpack_public_path__ + "static/media/slack.21370716.svg";